export default function SiteFooter() {
  const col1 = [
    { label: '最新挖掘', href: '#latest' },
    { label: '实锤合集', href: '#hammer' },
    { label: '录音曝光', href: '#audio' },
    { label: '聊天记录', href: '#chat' },
    { label: '人物热榜', href: '#rank' },
    { label: '吃瓜专区', href: '#zone' },
  ];
  const col2 = [
    '恋情考古所',
    '录音档案库',
    '截图显微镜',
    '饭圈经济黑匣',
    '塌房编年史',
  ];
  const helps = ['考古指南', '证据归档标准', '如何查证一条锤', '投稿与反馈'];

  return (
    <footer className="bg-gradient-to-br from-flame-800 via-flame-900 to-flame-950 text-paper-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          {/* brand */}
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="grid h-10 w-10 place-items-center rounded-lg bg-paper-50 text-flame-600">
                <i className="ri-flashlight-line text-xl" />
              </span>
              <div>
                <p className="font-display text-xl font-black text-paper-50">明星黑料</p>
                <p className="text-[11px] font-bold tracking-[0.25em] text-paper-200/80">证据整理 · 实锤现场</p>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-6 text-paper-200/80">
              以公开线索与网友素材为基础，按人物与事件做证据整理的吃瓜聚集地。不制造瓜，只帮你把瓜吃明白。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-wechat-2-line', 'ri-weibo-line', 'ri-youtube-line', 'ri-rss-line'].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label={ic}
                  className="grid h-9 w-9 cursor-pointer place-items-center rounded-full border border-paper-50/25 text-paper-100 transition-colors hover:bg-paper-50 hover:text-flame-700"
                >
                  <i className={`${ic} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* 站内导航 */}
          <nav>
            <p className="text-sm font-black text-gold-300">内容导航</p>
            <ul className="mt-4 space-y-2.5 text-sm text-paper-100/85">
              {col1.map((c) => (
                <li key={c.label}>
                  <a href={c.href} className="cursor-pointer hover:text-paper-50">
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 专区 */}
          <nav>
            <p className="text-sm font-black text-gold-300">吃瓜专区</p>
            <ul className="mt-4 space-y-2.5 text-sm text-paper-100/85">
              {col2.map((c) => (
                <li key={c}>
                  <a href="#zone" className="cursor-pointer hover:text-paper-50">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 帮助 */}
          <nav>
            <p className="text-sm font-black text-gold-300">吃瓜守则</p>
            <ul className="mt-4 space-y-2.5 text-sm text-paper-100/85">
              {helps.map((c) => (
                <li key={c}>
                  <a href="#top" className="cursor-pointer hover:text-paper-50">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href="#top"
              className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-paper-50 px-4 py-2 text-xs font-bold text-flame-700 hover:bg-gold-300"
            >
              <i className="ri-megaphone-line" />
              提交你的线索
            </a>
          </nav>
        </div>

        {/* 免责声明 */}
        <div className="mt-10 rounded-xl border border-paper-50/15 bg-paper-50/[0.06] p-4 text-xs leading-6 text-paper-200/70">
          <p className="flex items-center gap-1.5 font-bold text-gold-200">
            <i className="ri-scales-3-line" />
            免责声明
          </p>
          <p className="mt-1.5">
            本站所有内容均基于网络公开信息与网友投稿线索整理，仅供娱乐与信息参考，不代表当事人真实情况，亦不构成任何结论或指控。
            涉及个人隐私与名誉的内容，请以官方声明与司法认定为准；本站不传播、不转载未证实且可能侵权的个人隐私素材。
            若您认为相关内容侵犯了您的合法权益，请提供证明后联系本站，我们将在核实后第一时间处理。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-paper-50/15 pt-6 sm:flex-row">
          <p className="text-xs text-paper-200/70">© 2026 明星黑料 · 证据整理社区 —— 仅供娱乐参考，理性吃瓜</p>
          <a href="#top" className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-xs font-bold text-gold-300 hover:text-gold-200">
            回到顶部
            <i className="ri-arrow-up-line" />
          </a>
        </div>
      </div>
    </footer>
  );
}